import { img } from "@/lib/api";

export const Media = ({ image, video, alt, className = "", controls, testid }) => {
  if (video) return <video key={video} src={img(video)} poster={image ? img(image) : undefined} className={className} autoPlay muted loop playsInline controls={controls} aria-label={alt} data-testid={testid} />;
  if (image) return <img key={image} src={img(image)} alt={alt} className={className} data-testid={testid} />;
  return <div className={`${className} border border-dashed border-[var(--rose-soft)] bg-[var(--blush)] flex items-center justify-center text-xs text-[var(--taupe)] text-center p-4`} data-testid={testid}>Photo of this look coming soon</div>;
};
